import * as T from 'three'

/** A closed, domed cushion: soft center, tapered sewn edge, no block outline. */
export function createPillowGeometry(width: number, depth: number, height = 5) {
  const geometry = new T.SphereGeometry(1, 32, 20)
  const positions = geometry.getAttribute('position')
  const power = (v: number, e: number) => Math.sign(v) * Math.pow(Math.abs(v), e)
  for (let i = 0; i < positions.count; i++) {
    const x = positions.getX(i),
      y = positions.getY(i),
      z = positions.getZ(i)
    // Squarer plan than an ellipsoid; a puffy center and gently pinched corners.
    positions.setXYZ(
      i,
      (power(x, 0.55) * width) / 24,
      (power(y, 1.25) * height) / 24,
      (power(z, 0.55) * depth) / 24
    )
  }
  geometry.computeVertexNormals()
  return geometry
}

export function createPillow(width:number,depth:number,height=5){
  const power=(v:number,e:number)=>Math.sign(v)*Math.pow(Math.abs(v),e)
  const mesh = new T.Mesh(
    createPillowGeometry(width,depth,height),
    new T.MeshLambertMaterial({ color: 0xfffdf8, map: fabricTexture() })
  )
  mesh.name = 'soft-pillow'
  mesh.castShadow = true
  mesh.receiveShadow = true
  // A sewn perimeter follows the cushion's actual equator.
  const points = Array.from({ length: 97 }, (_, i) => {
    const a = (i / 96) * Math.PI * 2
    return new T.Vector3(
      ((power(Math.cos(a), 0.55) * width) / 24) * 1.002,
      0,
      ((power(Math.sin(a), 0.55) * depth) / 24) * 1.002
    )
  })
  mesh.add(
    new T.Line(
      new T.BufferGeometry().setFromPoints(points),
      new T.LineBasicMaterial({ color: 0xd6ccbe })
    )
  )
  return mesh
}

export function fabricTexture() {
  const size = 64,
    data = new Uint8Array(size * size * 4)
  for (let y = 0; y < size; y++)
    for (let x = 0; x < size; x++) {
      const shade = 246 + (x % 4 < 2 !== y % 4 < 2 ? 7 : 0)
      const i = (y * size + x) * 4
      data[i] = data[i + 1] = data[i + 2] = shade
      data[i + 3] = 255
    }
  const texture = new T.DataTexture(data, size, size, T.RGBAFormat)
  texture.colorSpace = T.SRGBColorSpace
  texture.wrapS = texture.wrapT = T.RepeatWrapping
  texture.repeat.set(6, 6)
  texture.generateMipmaps = true
  texture.minFilter = T.LinearMipmapLinearFilter
  texture.magFilter = T.LinearFilter
  texture.needsUpdate = true
  return texture
}
